<template>
  <div class="w-full">
    <Head title="Panel — Instytut" />
    <div class="mb-8">
      <h1 class="mb-2 text-3xl font-bold text-gray-900">Administracja strony Instytutu</h1>
      <p class="text-gray-600">
        Zarządzaj treścią i ustawieniami strony Instytutu (Instytut Genomiki i Medycyny Molekularnej).
      </p>
    </div>

    <div class="rounded-lg bg-white shadow-sm">
      <div class="px-6 py-5">
        <p class="text-gray-600">
          To jest panel administracyjny do zarządzania stroną statyczną Instytutu.
        </p>
        <div class="mt-4">
          <Link
            :href="$routes.institute()"
            class="text-sm font-medium text-indigo-600 hover:text-indigo-500"
            target="_blank"
          >
            Zobacz stronę Instytutu →
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import AdminInstituteLayout from '@/Layouts/AdminInstitute.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: AdminInstituteLayout,
};
</script>
